<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-07-05 14:46:49
 * @LastEditors: AowCt <awoct10@163.com>
 -->
<template>
  <div :class="['head container flex align_items_center']">
    <div @click="intoPage('/')" class="navbar-header">
      <img v-if="active" class="logo" :src="require(`@/assets/images/logo/${language == 'en' ? 'en_' : ''}logo.png`)" alt="" />
      <img v-else class="logo" :src="require(`@/assets/images/logo/${language == 'en' ? 'en_' : ''}logo_select.png`)" alt="" />
    </div>
    <el-menu
      ref="headMenu"
      :default-active="activeMenu"
      class="flex_1 flex justify_content_end"
      mode="horizontal"
      :unique-opened="true"
      @select="handleSelect"
    >
      <template v-for="item in menu">
        <template v-if="item.children">
          <template v-for="$item in item.children">
            <template v-if="$item.meta.show">
              <el-menu-item
                :index="$item.meta.checked === '/' ? '' : $item.meta.checked"
                v-if="!$item.children || $item.children.length === 0"
                :disabled="!$item.meta.show"
                :key="$item.meta.checked"
              >
                <span slot="title" v-html="$t($item.meta.title)"></span>
                <i class="el-menu-item-exart"></i>
              </el-menu-item>
              <template v-else>
                <el-submenu :index="$item.meta.checked" :key="$item.meta.checked" >
                  <template slot="title">
                    <span slot="title" @click="handleSelect($item.path)" v-html="$t($item.meta.title)"></span>
                    <i :class="['el-menu-item-exart', activeMenu.indexOf('innovative') != -1 && $item.meta.checked.indexOf('innovative') != -1 ? 'is-active' : '']"></i>
                  </template>
                  <template v-if="$item.children.length > 0">
                    <template v-if="$item.meta.checked.indexOf('innovative') != -1">
                      <li class="flex justify-between head-menu-box">
                        <div class="head-menu-wrap" v-for="childItem in getInnovativeRoutes($item.children)" :key="childItem.path">
                          <div :class="['head-menu-title', childItem.path == basePath ? 'active' : '']"><span class="ilblk" @click="handleSelect(childItem.path)" v-html="$t(childItem.title)"></span></div>
                          <div v-for="($item1, key) in childItem.children" :key="key">
                            <div class="head-menu-classify">
                              <p v-for="$item, $index in $t($item1.title)" :key="$index" v-html="$item"></p>
                            </div>
                            <div :class="['head-menu-item flex align_items_center', $item2.path == basePath ? 'active' : '']" v-for="$item2 in $item1.list" :key="$item2.path">
                              <span class="ilblk" @click="handleSelect($item2.path)" v-html="$item2.title"></span>
                              <img v-if="$item2.hot" :src="require('@/assets/images/icons/hot.png')" alt="" srcset="">
                            </div>
                          </div>
                        </div>
                      </li>
                    </template>
                    <template v-else>
                      <el-menu-item
                        v-for="childItem in $item.children"
                        :key="childItem.path"
                        :index="childItem.meta.checked"
                      >
                        <i
                          v-if="$route.path == childItem.meta.checked"
                          class="el-dropdown_item_extr_icon"/>
                        <span v-html="$t(childItem.meta.title)"></span>
                      </el-menu-item>
                    </template>
                  </template>
                </el-submenu>
              </template>
            </template>
          </template>
        </template>
      </template>
    </el-menu>
    <div class="fl header_language" @click="languageChange">
      <i class="language_right_line" />
      <svg-icon class="language_icon" icon-class="yuyan" />
      <span>{{lang != "en" ? 'ENGLISH' : '简体中文'}}</span>
    </div>
  </div>
</template>

<script>
import path from 'path'
import { mapGetters } from 'vuex'
// import { isExternal } from '@/utils/validate'
import { getRoutes } from '@/utils/routes'
export default {
  name: 'headMenu',
  inject: ['reload'],
  props: {
    defaultActive: {
      type: String
    },
    scroll: {
      type: Number
    },
    active: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      menu: []
    }
  },
  computed: {
    ...mapGetters([
      'language',
      'permission_routes'
    ]),
    activeMenu () {
      const route = this.$route
      const { path } = route
      return path.lastIndexOf('/') === path.length - 1 ? path.substr(0, path.lastIndexOf('/')) : path
    },
    basePath () {
      return this.$route.path
    }
  },
  created () {
    this.menu = getRoutes(this.permission_routes)
    // console.log(this.menu)
    this.lang = this.language
  },
  mounted () {
    // console.log(this.$refs.headMenu)
  },
  methods: {
    intoPage (path) {
      if (path === '/') {
        this.$router.push('/').then(() => {
          location.reload()
        })
      }
    },
    handleSelect (index, path) {
      console.log(index, 1, path, 2)
      if (index === null) {
        this.$router.push(path[0])
      } else if (index === this.basePath || (index === '' && this.basePath === '/')) {
      } else {
        if (index === this.$route.path) {
          this.$router.go(0)
        } else {
          if (index.indexOf('innovative') !== -1) {
            const menusArr = document.getElementsByClassName('el-menu--horizontal')
            for (let i = 0; i < menusArr.length; i++) {
              if (menusArr[i].getAttribute('class').indexOf(' el-menu') === -1) {
                menusArr[i].style.display = 'none'
              }
            }
          }
          if (path) {
            if (index === '') {
              this.$router.push('/').then(() => {
                location.reload()
              })
            } else {
              this.$router.push(index)
            }
          } else {
            if (index !== '') this.$router.push(index)
          }
        }
      }
    },
    resolvePath (routePath, _path) {
      // if (isExternal(_path)) {
      //   return _path
      // }
      // if (isExternal(this.basePath)) {
      //   return this.basePath
      // }
      // if (isExternal(routePath)) {
      //   return routePath
      // }
      let _url = '/'
      if (routePath === '/') {
        _url = '/'
      } else {
        _url = path.resolve(routePath, _path)
      }
      return _url
      // return path.resolve(routePath, _path)
    },
    getInnovativeRoutes (arr) {
      const innovative = []
      arr.forEach((item, index) => {
        if (item.meta.type && item.meta.type.classHead) {
          innovative.push({ path: item.meta.checked, title: item.meta.title, type: item.meta.type.classify, children: {} })
        } else {
          const _index = innovative.findIndex($item => $item.type === item.meta.type.classify)
          if (_index !== -1) {
            const item1 = innovative[_index]
            const title = this.language === 'en' ? '<span class="fontw">' + this.$t(item.meta.title).replace(' |', '</span> |') : '<span class="fontw">' + this.$t(item.meta.title).replace('-', '</span>-')
            if (item1.children[item.meta.type.name]) {
              item1.children[item.meta.type.name].list.push({
                title: title,
                path: item.meta.checked,
                hot: item.meta.hot
              })
            } else {
              item1.children[item.meta.type.name] = {
                title: item.meta.type.title,
                list: [{
                  path: item.meta.checked,
                  title: title,
                  hot: item.meta.hot
                }]
              }
            }
          }
        }
      })
      console.log(innovative)
      return innovative
    },
    async languageChange () {
      const language = this.language === 'zh' ? 'en' : 'zh'
      const _url = language === 'en' ? process.env.VUE_APP_HOST_EN : process.env.VUE_APP_HOST_ZH
      // this.$store.dispatch('app/setLanaguage', language).then(() => {
      //   // this.$i18n.locale = language
      //   window.location.replace(_url)
      // })
      window.location.replace(_url)
    }
  }
}
</script>

<style lang="less" scope>
@white: #ffffff;
.head {
  height: 90PX;
  font-size: 18PX;
  color: @white;
  transition: background 1s;
  .navbar-header {
    margin-right: 20PX;
    // padding-top: 6PX;
    cursor: pointer;
    .logo {
      width: 174PX;
      // height: 42PX;
      transition: all 0.2s; /*css动画效果，0.8秒完成*/
    }
  }
  .el-menu {
    background-color: transparent;
    border-bottom: none;
    position: relative;
    right: -18PX;
    .el-menu-item-exart {
      width: calc(100% - 40PX);
      height: 4PX;
      position: absolute;
      bottom: 0PX;
      left: 20PX;
      &:before,
      &:after {
        content: ""; /*单引号双引号都可以，但必须是英文*/
        width: 0;
        height: 3PX; /*下划线高度*/
        background: @white; /*下划线颜色*/
        position: absolute;
        bottom: 0;
        left: 50%;
        transition: all 0.2s; /*css动画效果，0.2秒完成*/
      }
      &.is-active {
        &:before {
          width: 50%;
          left: 0;
        }
        &:after {
          width: 50%;
          left: 49%;
        }
      }
    }
    .el-menu-item {
      color: @white;
      font-size: 18PX;
      height: 90PX;
      line-height: 90PX;
      border-bottom: none;
      padding: 0 18PX;
      font-weight: bold;
      &.is-active,
      &:not(.is-disabled):hover {
        background-color: transparent;
        color: @white;
        .el-menu-item-exart {
          &:before {
            width: 50%;
            left: 0;
          }
          &:after {
            width: 50%;
            left: 49%;
          }
        }
      }
      // &:last-child {
      //   padding-right: 0;
      // }
    }
    .el-submenu {
      .el-submenu__title {
        color: @white;
        font-size: 18PX;
        height: 90PX;
        line-height: 90PX;
        border-bottom: none;
        padding: 0 18PX;
        font-weight: bold;
        &:hover {
          background: transparent;
          .el-menu-item-exart {
            &:before {
              width: 50%;
              left: 0;
            }
            &:after {
              width: 50%;
              left: 49%;
            }
          }
        }
      }
      &.is-active, &.is-opened {
        .el-menu-item-exart {
          &:before {
            width: 50%;
            left: 0;
          }
          &:after {
            width: 50%;
            left: 49%;
          }
        }
      }
      .el-icon-arrow-down {
        color: #ffffff;
        font-size: 20PX;
        &::before {
          content: "\e790";
        }
      }
    }
  }
  .header_language {
    border-left: 1PX solid rgba(255, 255, 255, 0.4);
    height: 24PX;
    padding-left: 18PX;
    margin-left: 20PX;
    cursor: pointer;
    font-weight: bold;
    margin-top: 4PX;
    .svg-icon {
      font-size: 20PX;
      margin-right: 15PX;
      color: rgba(255, 255, 255, 0.64);
    }
  }
  &.navbar-default {
    background: #00A0E9;
  }
  &.navbar-default-active {
    background: #0B337B;
  }
}
.el-menu--horizontal {
  sup {
    margin-top: -20PX;
    // top: 0;
    // padding-right: 0;
    // transform:scale(0.66);
    // -webkit-transform:scale(0.66);
    // -moz-transform:scale(0.66);
    // -ms-transform:scale(0.66);
    // -o-transform:scale(0.66);
  }
}
// 1227 614
</style>
<style lang="less">
.pc .el-menu--popup {
  .head-menu-box {
    .head-menu-wrap {
      padding: 15PX 30PX 20PX 30PX;
      line-height: 30PX;
      font-size: 14PX;
      color: #333333;
      &:first-child {
        padding-right: 0;
      }
      .head-menu-title {
        line-height: 38PX;
        padding-bottom: 6PX;
        cursor: pointer;
        font-size: 16PX;
        font-weight: 600;
        &::after {
          content: '';
          display: block;
          width: 152PX;
          height: 2PX;
          background: linear-gradient(90deg, rgba(0,76,166,0.99) 0%, rgba(192,206,255,0) 100%);
        }
        &.active {
          color: #00A0E9;
        }
      }
      .head-menu-classify {
        padding-top: 10PX;
        opacity: 0.4;
        font-size: 14PX;
      }
      .head-menu-item {
        cursor: pointer;
        position: relative;
        transition: all .5s;
        &:hover {
          color: #00A0E9;
          // top: -2PX;
          transform: translateY(-4PX)
        }
        &.active {
          color: #00A0E9;
        }
      }
    }
  }
}
.pc.en .el-menu--popup {
  .head-menu-box {
    .head-menu-wrap {
      .head-menu-title {
        font-size: 16PX;
      }
      .head-menu-item {
        font-size: 14PX;
        color: #333333;
        &:hover {
          color: #00A0E9;
        }
        &.active {
          color: #00A0E9;
        }
      }
    }
  }
}
</style>
<style lang="less">
@media screen and (max-height: 660PX) {
  .head {
    height: 60PX;
    font-size: 16PX;
    .navbar-header .logo {
      width: 120PX;
      height: auto;
    }
    .el-menu .el-menu-item {
      padding: 0 14PX;
      font-size: 16PX;
      height: 60PX;
      line-height: 60PX;
    }
    .header_language {
      height: 18PX;
      .svg-icon {
        font-size: 16PX;
      }
    }
    .el-menu .el-submenu .el-submenu__title {
      font-size: 16PX;
      height: 60PX;
      line-height: 60PX;
    }
    .el-menu .el-menu-item-exart {
      height: 2PX;
      &::before, &::after {
        height: 2PX;
      }
    }
  }
}
@media screen and (max-width: 1280PX) and (max-height: 700PX) {
  .head {
    height: 60PX;
    font-size: 16PX;
    .navbar-header .logo {
      width: 120PX;
      height: auto;
    }
    .el-menu .el-menu-item {
      padding: 0 14PX;
      font-size: 16PX;
      height: 60PX;
      line-height: 60PX;
    }
    .header_language {
      height: 18PX;
      .svg-icon {
        font-size: 16PX;
      }
    }
    .el-menu .el-submenu .el-submenu__title {
      font-size: 16PX;
      height: 60PX;
      line-height: 60PX;
    }
    .el-menu .el-menu-item-exart {
      height: 2PX;
      &::before, &::after {
        height: 2PX;
      }
    }
  }
}
</style>
